import React from "react";
import "./quote.css";
import { BrandHeader, PageHero } from "./BrandChrome";

import QuestionModal from "./QuestionModal";
import DetailsModal from "./DetailsModal";
import OpeningHours from "./OpeningHours";
import DeliveryAddressModal from "./DeliveryAddressModal";
import {
  normaliseAddressChange,
  resolveDeliveryAddress,
} from "./addressChange";
import { getUrlParameterText } from "./urlTracking";

export default class Proforma extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reference: "",
      submittedRef: "",
      refType: "",
      refData: [],
      delAddr: null,
      addressChange: null,
      invAddr: null,
      customer: "",
      openingHours: null,

      showOverLimitMessage: false,
      accepted: false,

      showDeclineModal: false,
      showAcceptModal: false,
      showDeliveryAddressModal: false,
      declineFeedback: "",
      declined: false,

      proformaConverted: false,
      convertedRef: "",
      convertedCustomer: "",
    };
  }

  handleChange = (e) => this.setState({ reference: e.target.value });

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get("ref");
    if (ref && ref.trim() !== "") {
      this.setState({ reference: ref }, () => {
        this.handleSubmit({ preventDefault: () => {} });
      });
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { reference } = this.state;

    if (reference.trim() === "") {
      alert("Please enter a valid reference");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("reference", reference);

      // TODO: if your backend uses a different cmd for proformas, change this:
      const response = await fetch(
        "https://payments.fhbrundle.co.uk/api?cmd=ref_lookup",
        { method: "POST", body: formData }
      );

      const data = await response.json();

      if (data && data.ref_type && data.ref_data) {
        const addressChange = normaliseAddressChange(data.address_change);
        this.setState({
          submittedRef: reference,
          refType: data.ref_type,
          refData: data.ref_data,
          delAddr: resolveDeliveryAddress(data.del_addr, addressChange),
          addressChange,
          invAddr: data.inv_addr || null,
          customer: data.customer || data.ref_data[0]?.sopo_custr || "",
          openingHours: data.your_opening || null,

          // TODO: adjust these strings if backend uses different ref_type values
          declined: data.ref_type === "proforma_declined",
          proformaConverted: data.ref_type === "proforma_complete",
          convertedRef: data.ref_type === "proforma_complete" ? data.ref : "",
          convertedCustomer:
            data.ref_type === "proforma_complete" ? data.customer : "",
        });

        // logging
        const formData2 = new FormData();
        formData2.append("ref", reference);
        formData2.append("type", "proforma");
        formData2.append("info", "opened");
        formData2.append("text", getUrlParameterText());
        await fetch("https://payments.fhbrundle.co.uk/api?cmd=check", {
          method: "POST",
          body: formData2,
        });
      } else {
        alert(data.message || "No result found.");
        this.setState({ submittedRef: reference, refType: "", refData: null });
      }
    } catch (err) {
      console.error("Lookup failed:", err);
      alert("There was an error contacting the server.");
    }
  };

  accept_proforma = async (cust, ref, extra) => {
    try {
      const formData = new FormData();
      formData.append("type", "proforma");
      formData.append("ref", ref);
      formData.append("customer", cust);
      formData.append("their_ref", extra.current_ref);
      formData.append("due_date", extra.due_date);
      formData.append("notes", extra.notes);

      // If your backend uses the same conversion endpoint, keep it:
      const response = await fetch(
        "https://payments.fhbrundle.co.uk/api?cmd=ref_convert",
        { method: "POST", body: formData }
      );

      const data = await response.json();

      if (data.success) {
        this.setState({
          refType: "",
          refData: [],
          submittedRef: "",
          delAddr: null,
          addressChange: null,
          invAddr: null,
          customer: "",
          openingHours: null,
          showOverLimitMessage: false,
          accepted: true,
        });
      } else {
        alert(data.reason || "Failed to accept proforma.");
      }
    } catch (err) {
      console.error(err);
    }
  };

  generate_request = async (cust, ref, extra) => {
    const total = parseFloat(this.state.refData?.[0]?.sopq_invval || 0);
    if (total > 10000) {
      this.setState({ showOverLimitMessage: true });
      return;
    }

    const transactions = [{ type: "proforma", ref }];

    const jsonString = JSON.stringify({ transactions });
    const base64Encoded = btoa(jsonString);

    // logging
    const formData = new FormData();
    formData.append("ref", this.state.submittedRef);
    formData.append("type", "proforma");
    formData.append("info", "worldpay");
    formData.append("text", "");
    formData.append("their_ref", extra.current_ref);
    formData.append("due_date", extra.due_date);
    formData.append("notes", extra.notes);
     try{
    formData.append('terms', extra.terms); // 
    }catch(err){
      
    }
    await fetch("https://payments.fhbrundle.co.uk/api?cmd=check", {
      method: "POST",
      body: formData,
    });

    try {
      const safeCust = encodeURIComponent(cust || "UNKNOWN");
      const response = await fetch(
        `https://payments.fhbrundle.co.uk/api?cmd=build_transaction&cust=${safeCust}`,
        { method: "POST", body: base64Encoded }
      );

      const data = await response.json();
      if (data.URL) window.location = data.URL;
      else alert(data.reason || "Payment request failed.");
    } catch (err) {
      console.error(err);
      alert("There was a problem starting the payment process.");
    }
  };

 /* hasRestrictedProducts = () => {
    const { refData } = this.state;
    if (!Array.isArray(refData)) return false;
    return refData.some((item) => item?.product?.startsWith("CUT"));
  };*/

  hasRestrictedProducts = () => {
  const { refData } = this.state;
  if (!Array.isArray(refData)) return false;

  return refData.some(item => {
    const productMatch =
      item.product &&
      (item.product.startsWith("CUT") || item.product === "NS");

    const notepadMatch =
      item.notepad && item.notepad.includes("CUT");

    return productMatch || notepadMatch;
  });
};





  
  openDeclineModal = async () => {
    const formData = new FormData();
    formData.append("ref", this.state.submittedRef);
    formData.append("type", "proforma");
    formData.append("info", "decline_pressed");
    formData.append("text", "");
    await fetch("https://payments.fhbrundle.co.uk/api?cmd=check", {
      method: "POST",
      body: formData,
    });

    this.setState({ showDeclineModal: true });
  };

  closeDeclineModal = () =>
    this.setState({ showDeclineModal: false, declineFeedback: "" });

  submitDeclineFeedback = async () => {
    const { submittedRef, declineFeedback } = this.state;
    this.setState({ declined: true });
    this.closeDeclineModal();

    try {
      const formData = new FormData();
      formData.append("ref", submittedRef);
      formData.append("type", "proforma");
      formData.append("info", "decline");
      formData.append("text", declineFeedback);

      await fetch("https://payments.fhbrundle.co.uk/api?cmd=check", {
        method: "POST",
        body: formData,
      });
    } catch (err) {}
  };

  acceptModalStart = () => this.setState({ showAcceptModal: true });
  closeAcceptModal = () => this.setState({ showAcceptModal: false });

  proforma_modal_confirm = (extra) => {
    this.setState({ showAcceptModal: false });

    const row = this.state.refData?.[0];
    if (!row) return;

    
    this.generate_request(row.sopo_custr, row.ref, extra);
    //else this.accept_proforma(row.sopo_custr, row.ref, extra);
  };

  render() {
    const row0 = this.state.refData?.[0];
    const pay = true;// row0 ? row0.pay_type === "P" || row0.pay_type === "C" : false;
    const their_ref = row0 ? row0.their_ref : "";
const toPay =
  row0
    ? parseFloat(row0.sopo_invval) - parseFloat(row0.sopo_paidval)
    : 0;

const isPaid = toPay <= 0;
    return (
      <div className="App app-shell">
        <BrandHeader title="Proforma payment" subtitle="Review and pay online" />
        <PageHero
          title="Review your proforma"
          description="Enter your proforma reference to review the order and make a secure payment."
        >
        <form className="lookup-form" onSubmit={this.handleSubmit}>
          <div>
            <input
              type="text"
              name="reference"
              value={this.state.reference}
              onChange={this.handleChange}
              placeholder="Enter proforma reference"
              className="form_input"
            />
          </div>

          <div style={{ marginTop: "10px" }}>
            <button type="submit" className="lookup_link">
              <div>Submit</div>
            </button>
          </div>
        </form>
        </PageHero>

        {this.state.submittedRef && (!this.state.refType || !this.state.refData) && (
          <div className="pad10" style={{ marginTop: "20px" }}>
            <strong>Looking up:</strong> {this.state.submittedRef}
          </div>
        )}

        {this.state.submittedRef &&
          (!this.state.refType ||
            !this.state.refData ||
            this.state.refData.length === 0) && (
            <div className="no_results_message" style={{ marginTop: "20px", color: "white" }}>
              No results found for reference <strong>{this.state.submittedRef}</strong>.
            </div>
          )}

        <div id="quote_container">
          {this.state.refType === "proforma_complete" && this.state.proformaConverted && (
            <div className="quote_converted_msg">
              <div className="tick">✓</div>
              <div>
                Proforma <strong>{this.state.convertedRef}</strong> has been successfully converted to order.
              </div>
            </div>
          )}

          {this.state.showOverLimitMessage && (
            <div className="limit_warning" style={{ marginTop: "20px", color: "#ffcc00", fontWeight: "bold" }}>
              Orders over £10,000 cannot be performed online. Please call your sales office.
            </div>
          )}

          {this.state.declined === true && (
            <div className="quote_accepted_msg">
              <div className="tick">X</div>
              <div>Proforma Declined.</div>
            </div>
          )}

          {this.state.accepted && (
            <div className="quote_accepted_msg">
              <div className="tick">✓</div>
              <div>Proforma accepted successfully.</div>
            </div>
          )}

          <DetailsModal
            visible={this.state.showAcceptModal}
            onClose={this.closeAcceptModal}
            onSubmit={this.proforma_modal_confirm}
            current_ref={their_ref}
            confirmationLabel="Proforma confirmation"
            referenceEditable={false}
            pay={pay}
            due_date={""}
            notes={""}
          />

          <QuestionModal
            visible={this.state.showDeclineModal}
            onClose={this.closeDeclineModal}
            onSubmit={this.submitDeclineFeedback}
            feedback={this.state.declineFeedback}
            documentLabel="proforma"
            setFeedback={(text) => this.setState({ declineFeedback: text })}
          />

          <DeliveryAddressModal
            visible={this.state.showDeliveryAddressModal}
            reference={this.state.submittedRef}
            referenceType="proforma"
            deliveryAddress={this.state.delAddr}
            onClose={() => this.setState({ showDeliveryAddressModal: false })}
            onSaved={(delAddr) =>
              this.setState({
                delAddr,
                addressChange: { state: 1, address: null },
              })
            }
          />

          {/* Summary */}
          {this.state.refType === "proforma" &&
            Array.isArray(this.state.refData) &&
            this.state.refData.length > 0 && (
              <div className="quote_container">
                <div className="quote_summary">
                  <div className="quote_summary_ref">
                    <div className="quote-reference-row quote-reference-row--first">
                      <span className="summary_label">Our ref:</span>
                      <span className="quote-reference-value">{row0.ref}</span>
                    </div>
                    <div className="quote-reference-row">
                      <span className="summary_label">Your ref:</span>
                      <span className="quote-reference-value">{row0.their_ref}</span>
                    </div>
                    <OpeningHours
                      value={this.state.openingHours}
                      customer={this.state.customer}
                      deliveryCode={this.state.delAddr?.del_code}
                      reference={this.state.submittedRef}
                    />
                  </div>

                  <div className="quote_summary_del_addr">
                    {this.state.delAddr && (
                      <div className="quote-address-card">
                        <div className="quote-address-card__heading">
                          <div>
                            <div className="summary_label">Delivery Address</div>
                            {this.state.addressChange && (
                              <span className="quote-address-amended">
                                Amended address
                              </span>
                            )}
                          </div>
                          <button
                            type="button"
                            className="quote-address-edit-button"
                            onClick={() =>
                              this.setState({ showDeliveryAddressModal: true })
                            }
                          >
                            Alter
                          </button>
                        </div>
                        <div>{this.state.delAddr.del_name}</div>
                        <div>{this.state.delAddr.del_add1}</div>
                        <div>{this.state.delAddr.del_add2}</div>
                        <div>{this.state.delAddr.del_add3}</div>
                        {this.state.delAddr.del_add4 && <div>{this.state.delAddr.del_add4}</div>}
                        <div>
                          <b>{this.state.delAddr.del_postcode}</b>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="quote_summary_inv_addr">
                    {this.state.invAddr && (
                      <div className="quote-address-card">
                        <div className="summary_label">Invoice Address</div>
                        <div>{this.state.invAddr.cus_name}</div>
                        <div>{this.state.invAddr.cus_add1}</div>
                        <div>{this.state.invAddr.cus_add2}</div>
                        <div>{this.state.invAddr.cus_add3}</div>
                        {this.state.invAddr.cus_add4 && <div>{this.state.invAddr.cus_add4}</div>}
                        <div>
                          <b>{this.state.invAddr.cus_postcode}</b>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

          {/* Items list – identical layout */}
          {this.state.refType === "proforma" &&
            Array.isArray(this.state.refData) &&
            this.state.refData.length > 0 && (
              <div className="ProductLanding quote line-items-panel">
                <div className="ProductLandingGrid">
                  {this.state.refData.map((item, index) => (
                    <div key={index} className="product_table prodlayoutdefault">
                      <div className="product_card_img_container">
                        <a
                          className="product_card_link"
                          href={`https://www.fhbrundle.co.uk/products/${item.product}?utm_source=pbl&utm_medium=proforma&utm_campaign=${this.state.submittedRef}`}
                        >
                          <img
                            className="product_card_img"
                            src={`https://samsara-web.s3-eu-west-1.amazonaws.com/webimages/${item.product}/${item.product}x140.jpg`}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                "data:image/svg+xml;base64," +
                                btoa(
                                  '<svg xmlns="http://www.w3.org/2000/svg" width="1" height="1"><rect width="1" height="1" fill="white"/></svg>'
                                );
                            }}
                            alt={item.product}
                          />
                        </a>
                      </div>

                      <div className="product_card_content">
                        <div className="product_card_desc">
                          <a
                            className="product_card_link"
                            href={`https://www.fhbrundle.co.uk/products/${item.product}__${item.desc.replaceAll(
                              " ",
                              "_"
                            )}?utm_source=pbl&utm_medium=proforma&utm_campaign=${this.state.submittedRef}`}
                          >
                            {item.desc}
                          </a>
                        </div>

                        <div className="product_card_code">{item.product}</div>

                        {item.notepad && item.notepad !== "@@" && (
                          <div className="product_card_note">{item.notepad.replaceAll("@", "")}</div>
                        )}

                        <div className="product_card_bottom">
                          <div className="prod_price">
                            <div className="quote_item">
                              <div className="quote_label">QTY</div>
                              <div className="quote_value">x{parseFloat(item.qty).toFixed(2)}</div>
                            </div>
                            <div className="quote_item">
                              <div className="quote_label">PRICE</div>
                              <div className="quote_value">£{parseFloat(item.price).toFixed(2)}</div>
                            </div>
                            <div className="quote_item">
                              <div className="quote_label">LINE TOTAL</div>
                              <div className="quote_value">£{parseFloat(item.line_price).toFixed(2)}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

          {/* Totals */}
          {this.state.refType === "proforma" &&
            Array.isArray(this.state.refData) &&
            this.state.refData.length > 0 && (
              <div className="quote_container">
                <div className="quote_summary_val">
                  <div className="quote_summary_values">
                    <div>
                      <span className="summary_label">Subtotal (ex VAT):</span> £
                      {parseFloat(row0.sopo_invgds).toFixed(2)}
                    </div>
                    <div>
                      <span className="summary_label">Total (inc VAT):</span>{" "}
                      <strong>£{parseFloat(row0.sopo_invval).toFixed(2)}</strong>
                    </div>

<div>
                      <span className="summary_label">Amount Paid:</span>{" "}
                      <strong>-£{parseFloat(row0.sopo_paidval).toFixed(2)}</strong>
                    </div>
                    <div>
                      <span className="summary_label">To Pay:</span>{" "}
                      <strong>£{toPay.toFixed(2)}</strong>
                    </div>
                  </div>
                </div>
              </div>
            )}

          {/* Actions — NO “Edit” option */}
          {this.state.refType === "proforma" &&
            Array.isArray(this.state.refData) &&
            this.state.refData.length > 0 && (
              <div className="quote_container">
                <div className="quote_summary">
                  <div className="quote_actions">
                   <button
  className="pay_button decline_but"
  onClick={this.openDeclineModal}
  disabled={isPaid}
>
  Decline Proforma
</button>

<button
  className="pay_button"
  onClick={() => this.acceptModalStart()}
  disabled={isPaid}
>
  Make payment
</button>
                    

                    {/* Intentionally removed “Edit Online” */}
                    {/* You can also hide if restricted: { !hasRestricted && (...) } */}
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}
